export interface AblyPayload {
  origin: string
  product: string
  reference: string
  number_origin: number
  number_destination: string
}

function mountAblyPayload(
  applicationId: string,
  extensionNumber: number,
  phoneNumber: string,
): AblyPayload {
  return {
    origin: 'surprise',
    product: 'auto-refi',
    reference: applicationId,
    number_origin: extensionNumber,
    number_destination: phoneNumber,
  }
}

export { mountAblyPayload }
